export default {
    //常规
    loading:"加载中",
    quantity:"数量",
    name:"名称",
    all:"全部",
    yes:"是",
    no:"否",
    delete:"删除",
    edit:"编辑",
    confirm:"确认",
    print:"打印",
    isprint:"正在打印",
    A_sheet_is_being_printed:"正在打印面单",
    Check_the_details:"查看",
    BatchQuery:"批量查询",
    successful_operation:"操作成功!",
    The_query_is_successful:"查询成功",
    operation_failed:"操作失败！",
    more:"更多",
    System_Exception:"系统异常",
    Confirm_whether_to_change_the_password:"是否确认修改密码",
    Do_not_repeat_operation:"请勿重复操作",
    Separated_by_commas_Spaces_and_newlines:'单号用逗号,空格,换行分隔',
    The_input_content_is_incorrect_please_re_enter:'输入的内容有误，请重新输入',
    //登录
    Chinese:"中文",
    English:"English",
    WMS_system:"WMS系统",
    UserAccount:"用户账号",
    password:"密码",
    RememberPassword:"记住密码",
    ForgotPassword:"忘记密码",
    RegisterAccount:"注册账号",
    login:"登录",
    Please_enter_a_user_account:"未输入用户账号",
    Please_enter_the_user_password:"未输入密码",
    SignIn:"登录中",
    LoginSuccessful:"登录成功",
    open_in_new_window : "新窗口打开",
    Do_not_input_Chinese_please_input_again:"禁止输入中文，请重新输入！",

    //菜单
    Momentumfees:"一件代发费",
    sys_wms_order:"订单",
    Outbound:"出库",
    current_position:"当前位置",
    Order:"订单",
    pendingOrders:"待发货订单",
    sys_wms_mpd:"多品配货",
    sys_wms_mps:"多品分拣",
    mutiShipment:"多品发货",
    Single_product_distr:"单品配货",
    singleShipment:"单品发货",
    Weigh_out_of_warehouse:"称重出库",
    Basic_configuration:"基础配置",
    shippingContro:"发货控制",
    missionListInf:"任务单信息",
    basket:"篮子列表",
    currencyInfo:'SKU固定收费',
    Packaging_material_settings:"包材设置",
    consumables:"耗材类型",
    log:"日志",
    oprateLog:"操作日志",
    SKU_Flat_fee:"SKU固定收费",
    packagSetting:"耗材管理",
    Order_completed:"已完成订单",
    authority_management:"权限管理",
    Please_enter_a_keyword_to_search:"请输入关键字进行搜索",
    Input_to_add:"输入添加",
    Search_to_add:"搜索添加",
    Support_batch_addition_one_SKU_per_line_support_excel_copy_and_paste:"支持批量添加,每行一个SKU(支持excel复制黏贴)",
    Batch_addition_is_supported_Please_enter_customer_ID_and_warehouse_first_enter_keyword_search_and_click_Multiple_selection:"支持批量添加,请先输入客户ID和仓库,输入关键词搜索,点击多选",

    //待发货订单
    Please_enter_the_tracking_number:"请输入单号",
    Warehouse_note:'仓库备注',
    Cancel_task_list_restock:"取消任务单重新配货",
    Task_sheet_distribution:"任务单重新配货",
    Search_criteria:"搜索条件",
    The_task_ticket_number:"任务单号",
    Customer_ID:"客户ID",
    platform:"平台",
    shop:"店铺",
    warehouse:"仓库",
    order_number:"订单号",
    transaction_number:"交易号",
    waybill_number:"运单号",
    fj_basket:"分拣篮子",
    Sort_the_basket_head:"分拣篮子头",
    Sorting_basket_number:'分拣篮子编号',
    ph_basket:"配货筐",
    ph_person:"配货员",
    fj_person:"分拣员",
    fh_person:"发货员",
    transfer_staff:"转入员",
    logistics_channel:"物流渠道",
    select_date:"选择日期",
    search:"搜索",
    type:"类型",
    state:"状态",
    Priority_delivery:"是否优先发货",
    label:"标签",
    Bulk_Redistribution:"批量重新配货",
    button:"批量重新配货",
    Batch_delete_tasks:"批量删除任务",
    Set_up_priority_shipping:"设置优先发货",
    Cancel_Priority_Shipping:"取消优先发货",
    print_pick_list:"打印拣货单",
    Print_side_slip_labels:"打印面单标签",
    Printing_sheet_successfully:'打印面单成功!',
    Is_Print_side_slip_labels:"是否打印面单标签",
    Print_side_slip_labels_and_picking_slips:"打印面单标签及拣货单",
    Remaining_closing_time_of_the_order:"订单剩余关闭时间",
    basket_number:"篮子编号",
    time:"时间",
    country:"国家",
    oprate:"操作",
    operation_log:"操作日志",
    thumbnail:"缩略图",
    Bar_code_of_goods:"商品条码",
    Allocated_quantity:"已配货数量",
    stock_position:"仓位",
    Single_item_quantity:"单品单量",
    A_large_number_of_single_products:"单品多量",
    sys_wms_more_product:"多品",
    The_task_was_not_generated:"未生成任务",
    To_be_stocked:"待配货",
    Orders_in_the_fulfillment:"配货中的订单",
    Pending_sorting_tasks:"待分拣任务",
    Pending_sorting:"待分拣",
    Sorting_tasks:"分拣任务中",
    Pending_shipment:"待发货",
    In_transit:"发货中",
    Irregularity_in_delivery:"配货异常",
    The_sorting_task_is_abnormal:"分拣任务异常",
    Shipment_exception:"发货异常",
    finish:"完成",
    log_list:"日志列表",
    Document_ID:"单据ID",
    task_order_number:"任务单号",
    order_id:"订单ID",
    Operation_type:"操作类型",
    Operation_Description:"操作描述",
    Operator:"操作人",
    please_select_Operator_type:"请选择操作人类型",
    Please_enter_the_operator:"请输入操作人",
    creation_time:"创建时间",
    No_delivery_basket:"暂无配货筐",
    No_sorting_basket:"暂无分拣篮子",
    time_left:"剩余",
    overdue:"逾期",
    days:"天",
    hours:"时",
    minutes:"分",
    copy:"复制",
    copu_successful:"复制成功",
    verify_the_time:"确认时间", 
    Transfer_to_wms_time:"转入wms时间",
    Delivery_time:"配货时间",
    sorting_time:"分拣时间",
    delivery_time:"发货时间",
    Please_tick_the_content_first:"请先勾选内容",
    start_date:"开始日期",
    end_date:"结束日期",
    to:"至",

    //单品配货
    tips:"温馨提示",
    singmath_tip1:"首先准备一个配货筐",
    singmath_tip2:"直接扫描商品就可以进行配货",
    singmath_tip3:"点击数字可以进行全部配货",
    Task_mode:"任务方式",
    Get_task:"获取任务",
    Warehouse_partition:"仓库分区",
    Distribution_box_scanning_box:"配货框扫描框",
    Distribution_basket_code:"配货筐编码",
    Barcode_scanning_box_of_goods:"商品条码扫描框",
    Currently_there_are:"当前还有",
    Class_goods_need_to_be_distributed:"类商品需要配货",
    picture:"图片",
    Allocated_goods:"已配货",
    To_be_distributed:"待配货",
    stock:"库存",
    details:"详情",
    Logistics_channel:"物流渠道",
    Please_enter_customer_ID:"请输入客户ID",
    Scan_the_distribution_basket:"扫描配货筐",
    please_scan_the_distribution_basket:"请扫描配货筐",
    //单品发货
    Complete_the_shipment:"补印出货",
    singship_tip1:"扫描配货筐或者配货批次",
    singship_tip2:"将配货好的商品拿过来，直接扫描商品就可以进行发货",
    singship_tip3:"点击数字可以批量发货",
    Scan_barcode_box_of_goods:"扫描商品条码框",
    Scan_barcode_of_goods:"扫描商品条码",
    Order_weight_box:"订单重量框",
    Order_weight:"订单重量",
    Reprint_and_ship:"重新补印出货",
    Rescan_code:"重新打印",
    Packaging_requirements:"包装要求",
    Packaging_material:"包材",
    Package_photos:"包裹照片",
    Show_package_photo:"显示包裹拍照照片",
    Order_information:"订单信息",
    The_number_of_current_commodity_types: "当前商品种类数量",
    kinds:"种",
    total:"总共",
    Shipper:"配货员",
    Packaging_material_requirements:"包材要求",
    package_photo:"包裹照片",
    Waybill_number:"运单号",
    Has_been_inspected:"已验货",
    pending_inspection:"待验货",
    abnormal_delivery:"发货异常",
    Photograph:"拍照",
    Enter_key_to_take_a_photo:"回车键拍照",
    Please_weigh_the_order:"请进行订单称重",
    Please_photos_the_order:"请进行订单拍照",
    Out_of_stock_successfully:"出库成功",
    The_order_number_cannot_be_empty:"输入的订单号不能为空！",
    submit:"提交",
    No_order_at_present:"暂无订单",

    //多品配货
    multimath_tip1:"首先准备一个配货筐",
    multimath_tip2:"扫描配货筐 ",
    multimath_tip3:"直接扫描商品就可以进行配货",
    multimath_tip4:"点击数字可以进行全部配货",
    Modify_the_delivered_quantity:"修改已配货数量",
    Fulfilled_quantity_exceeds_maximum_limit:"已配货数量超过所需数量",
    Flag_exception:"标记异常",
    Please_scan_the_basket_head_first_for_distribution:"请先扫描篮子头进行配货",
    Please_first_distribution:'请先配置',
    Distribution_of_failure:"配货失败",

    //多品发货
    IF_Need_to_take_pictures:'是否需要拍照',
    IF_Need_to_be_weighed:'是否需要称重',
    multiship_tip1:"将分拣好的分拣篮子拿过来，直接扫描分拣篮子，再扫描商品进行发货",
    multiship_tip2:"可以在系统设置中设置是否需要验货发货，默认需要",
    Priority_Shipping_Orders:"优先发货订单",
    Please_scan_the_distribution_frame:"请扫描配货框",
    Scanning_sorting_blue_head:"扫描分拣蓝子",
    Scanning_sorting_blue_head2:"扫描分拣蓝子头",
    Number_of_current_product_types:"当前商品种类数量",
    kind:"种",
    indivual:"个",
    dispatcher:"配货员",
    Shipping_Basket:"分拣篮子",
    Preview_photo:"预览照片",
    reshoot:"重新拍摄",
    No_photos_yet:"暂无照片",
    determine:"确定",
    Spaces_Chinese_characters_and_special_characters_are_not_allowed:'不允许出现空格、中文、特殊字符',
    The_value_cannot_be_blank_or_contain_Chinese_characters:'不允许为空或出现中文!',
    Fail_to_print_the_plane_list_Contact_the_administrator_in_time_The_error_message_is_as_follows:'打印面单失败，请及时联系管理员进行处理，错误信息为',
    If_weighing_fails__contact_the_administrator_in_time_The_error_message_is:'称重失败,请及时联系管理员进行处理，错误信息为',
    The_interface_communication_fails_Contact_the_administrator_in_time:'接口通讯失败，请及时联系管理员进行处理',
    Multi_product_delivery_is_not_allowed_to_operate_three_party_warehouse_orders:'多品发货不允许操作三方仓订单',

    //称重出库
    weightout_tip1:"适用于面单打出来了，货已经包好的（单品标签打印、多品标签打印），不需要再次走配货流程的包裹。",
    Transaction_number_only:"仅交易号",
    Transaction_number_and_order_weight:"交易号和订单重量",
    Waybill_No_only:"仅运单号",
    Shipment_number_and_order_weight_only:"仅运单号和订单重量",
    Shipping_format:"发货格式",
    Freight_mode:"货运方式",
    Scan_delivery_information:"扫描配送信息",


    //篮子列表
    add_basket_head:"新增篮子头",
    save:"保存",
    Cancel:"取消",
    sequence:"序号",
    Please_enter_basket_header:"请输入篮子头",
    Add_basket:"新增篮子",
    Edit_basket:"编辑篮子",
    Basket_Type:"篮子类型",
    Basket_Type_Name:"篮子类型名称",
    Add_Basket_Type:"新增篮子类型",
    basket_head:"篮子头",
    basket_name:"篮子名字",
    Please_select_a_basket_type:"请选择篮子类型",
    Please_enter_the_basket_name:"请输入篮子名名称",
    Please_enter_the_basket_type_name:"请输入篮子类型名称",
    Basket_description:"篮子描述",
    Please_enter_a_basket_description:"请输入篮子描述",
    sorting_basket:"分拣篮子",
    distribution_basket:"配货筐",
    return_basket:'退货蓝子',
    quality_inspection_basket:"质检篮子",
    other_types:"其他类型",
    operator:"操作员",
    Operation_time:"操作时间",
    Can_only_contain_letters_and_numbers:"只能包含字母和数字",
    print_basket_number:"打印篮子编号",
    starting_number:"起始编号",
    end_number:"结束编号",
    The_label_specification:"标签规格",
    custom_specification:"自定义标签规格",

    //占用篮子
    basketOccupied:"占用篮子",
    to_be_dispatched:"待配货",
    to_be_sorted:"待分拣",
    Sorting:"分拣中",
    to_be_delivered:"待发货",
    in_delivery:"发货中",
    completed:"已完成",
    out_of_stock:"已出库",
    task_order_status:"任务单状态",
    Order_Status:"订单状态",

    //sku固定信息
    Add_currency:"新增收费",
    Query:"查询",
    change_currency:"修改货币",
    range_fee:"范围费用",
    number_of_ranges:"范围数量",
    out_of_range_charges:"超出范围收费",
    Charge_Type:"收费项目",
    Charge_items:"收费类型",
    Add_currency_information:"新增收费信息",
    Edit_currency_information:"编辑收费信息",
    special_price:"特殊价格",
    default_price:"默认价格",
    discounted_price:"优惠价",
    Listing_fee:"上架费",
    order_processing_fee:"订单处理费",
    Destruction_delisting_fee:"销毁下架费",
    Return_listing_fee:"退件重新上架费",
    currency:"货币",
    Please_enter_SKU:"请输入SKU",
    Please_enter_User_Stock:"请输入仓库",
    Please_enter_a_range_fee:"请输入范围费用",
    Please_enter_the_number_of_ranges:"请输入范围数量",
    Please_enter_Charge_items:"请输入收费项目",
    not_available_SKU_Flat_fee:'暂无SKU固定收费！',

    //发货控制
    SKU:"SKU",
    Add_Shipping_Control:"新增发货控制",
    Add_Shipping_Control_Information:"新增发货控制信息",
    Modify_Shipping_Control_Information:"修改发货控制信息",
    number_of_tasks:"任务单数量",
    Task_order_type:"任务单类型",
    Please_enter_the_order_quantity:"请输入任务单数量",
    Please_enter_a_task_order_type:"请输入任务单类型",
    The_task_order_type_can_only_be_uppercase_letters_and_numbers:"任务单类型只能为大写字母和数字",
    Order_quantity_of_task_order_type:"任务单类型下订单数量",
    Whether_to_weigh:"是否称重",
    whether_to_take_pictures:"是否拍照",
    Whether_to_inspect_the_goods:"是否验货",
    Whether_to_process_the_whole_order:"是否整单处理",
    Modified_by:"修改人",
    founder:"创建人",
    tip:"提示",
    Confirm_before_deleting:"您确认要删除这一条数据吗，删除之后将无法恢复！",
    single:"单品",
    Multi_product:"多品",
    other:'其他',
    Single_address_without_face:"无面单地址",
    Single_item_delivery_must_be_processed_as_a_whole:"单品发货必须为整单处理",
    Single_product_delivery_must_be_processed_as_a_whole_and_multiproduct_delivery_can_be_arranged_to_be_delivered_at_the_same_time_of_sorting_or_after_all_sorting:"单品发货必须为整单处理，多品发货可设置 边分拣边发货 或 全部分拣完后再发货",

    //任务单信息
    document_name:"单据名称",
    document_description:"单据描述",
    document_header:"单据头",
    Document_reset_string:"单据复位字符串",
    reset_string_counter:"复位字符串计数器",
    Add_document:"新增单据",
    Please_enter_a_document_name:"请输入单据名称",
    Please_enter_a_document_description:"请输入单据描述",
    Add_document_information:"新增单据信息",
    Edit_document_information:"编辑单据信息",

    //多品分拣
    Distribution_basket_code_or_batch:"配货筐编码或批次",
    cutline:'图例',
    Scanning_tasks_bar_code_or_batch: "扫描任务条码或批次",
    Sorting_basket_heads: "分拣篮子",
    Sorting_basket_heads2: "分拣篮子头",
    Scan_the_distribution_basket_or_batch:"扫描配货筐或者配货批次 ",
    Scan_the_sorting_basket_heads:"扫描分拣篮子",
    Scan_the_sorting_basket_heads2:"扫描分拣篮子头",
    The_scanned_goods_are_placed_into_the_corresponding_sorting_basket_according_to_the_prompts:"扫描商品 根据提示放入对应的分拣篮子中",
    End_of_the_sorting:"分拣结束",
    Sorting_Details: "分拣详情",
    Basket_List:"篮子",
    ProductID:"商品编号",
    theOriginal:"原厂",
    HasBeenSorting:"已分拣",
    Gross:"总量",
    batch_number:"批次号",
    Pick_exceptions:"挑拣异常",
    Are_you_sure_to_mark_the_product_as_abnormal:"是否确定给商品标记异常",
    Please_enter_exception_remarks:"请输入异常备注",
    Picked_List:"已挑拣列表",
    The_exception_remarks_cannot_be_empty:'异常备注不能为空',
    Modify_Picked_Quantity:"修改已挑拣数量",
    Picked_Quantity_Exceeds_Required_Quantity:"已挑拣数量超过所需数量",
    Task_details:"任务详情",
    sorting_details: "挑拣详情",
    goods_name:"商品名称",
    All_the_current_sorting_baskets_have_been_selected:"当前分拣篮子全部挑拣完成",
    All_the_current_sorting_tasks_have_been_selecte:"当前分拣任务全部挑拣完成",
    The_current_sorting_basket_has_been_marked_abnormal:"当前分拣篮子已标记异常",
    The_sorting_basket_delivery_is_complete:"该分拣篮子发货完结",
    The_delivery_of_the_distribution_basket_is_complete:"该配货筐发货全部完结",

    //包材设置
    Add_packing_material:"新增包材",
    Add_packaging_material_information:"新增包材信息",
    Packaging_material_name:"包材名称",
    Packaging_material_size:"包材尺寸",
    Packaging_RMB:"包材RMB",
    Please_enter_the_name_of_the_packaging_material:"请输入包材名称",
    Please_enter_the_packaging_size:"请输入包材尺寸",
    Please_enter_the_packaging_material_RMB:"请输入包材RMB",
    Packaging_material_code:"包材编码",
    Packaging_material_type:"包材类型",
    Packaging_material_fee:"包材费",
    
    //菜单列表
    Menu_list: "菜单列表",
    add_Menu: "新增菜单",
    Edit_Menu: "编辑菜单",
    Menu_Name: "菜单中文名称",
    Menu_EnName: "菜单英文名称",
    Please_enter_the_Menu_Name: "请输入菜单名称",
    Please_enter_the_Menu_EnName:"请输入菜单名称",
    Menu_Icon: "图标",
    Menu_Path: "访问地址",
    Please_enter_the_Menu_Path:"请输入访问地址",
    Menu_Sort: "排序",
    Menu_Code: "菜单编码",
    MenuPlease_enter_the_Menu_Code:"请输入菜单编码",
    Menu_Name_Not_Null: "菜单中文名称不能为空",
    Menu_EnName_Not_Null:"菜单英文名称不能为空",
    Menu_Code_Not_Null: "菜单编码不能为空",
    Paren_Menu:"父级菜单",
    Please_Select_Paren_Menu: "请选择父级菜单",
    Menu_Level: "菜单级别",
    Menu_Stair: "一级",
    Menu_Second: "二级",
    Menu_Three: "三级",
    Please_Select_Menu_Level: "请选择父级菜单",
    Visible: "是否可见",
    Remark: "备注",
    
    //角色列表
    sysRole: "角色列表",
    Role_CnName: "角色中文名称",
    Role_EnName: "角色英文名称",
    Role_Code: "角色唯一编码",
    Role_IsStart: "是否启用",
    Add_Role: "新增角色",
    Edit_Role: "新增角色",
    Role_Name: "角色名称",
    Please_Input_Role_Name:"请输入角色名称",
    Please_Input_Role_CnName:"请输入中文角色名称",
    Please_Input_Role_EnName:"请输入中文角色名称",
    Please_Input_Role_Code: "请输入唯一编码",
    Reset: "重置",
    Role_Sort: "排序",
    Role_CnName_Not_Null:"角色中文名称不能为空",
    Role_EnName_Not_Null:"角色英文名称不能为空",
    Role_Code_Not_Null: "角色唯一编码不能为空",
    Accredit_Menu:"授权菜单",
    Accredit_Stock: "授权仓库",
    More:"更多",
    Editing_role:"编辑角色",
    
    //用户列表
    sysUser: "用户列表",
    User_Code: "用户编号",
    User_Name: "用户名称",
    User_Role: "角色",
    User_Branch:"部门",
    User_Phone: "手机",
    User_Rank: "职称",
    User_Email: "邮箱",
    User_EntryDate:"入职日期",
    User_Status: "用户状态",
    User_Type: "用户类型",
    User_Sex: "性别",
    User_Emergency: "紧急联系电话",
    User_PassWord: "密码",
    User_confirmPassWord: "确认密码",
    User_IDNumber: "身份证",
    User_Address: "住址",
    User_Unit: "单位",
    User_Stock: "仓库",
    Please_Input_User_Name: "请输入用户名称",
    Please_Input_User_Code:"请输入用户编码",
    Please_Input_User_PassWord:"请输入密码",
    Please_Input_User_confirmPassWord: "请输入确认密码",
    Please_Input_User_Rank: "请输入职称",
    Please_Input_User_IDNumber: "请输入身份证",
    Please_Input_User_Emergency: "请输入紧急联系电话",
    Please_Input_User_Phone: "请输入手机",
    Please_Input_User_Address: "请输入住址",
    Please_Input_User_Email: "请输入邮箱",
    Please_Input_User_Unit: "请输入单位",
    Please_Input_User_Status: "请选择状态",
    Please_Input_User_Role: "请选择角色",
    Please_select_a_print_type:"请选择打印类型",
    print_type:"打印类型",
    Entered_passwords_differ: "两次输入的密码不一致",
    The_password_contains_less_than_characters:"密码长度不能小于6位",
    Add_User: "新增用户",
    Please_Select: "请选择",
    Please_Select_Date: "请选择时间",
    Enabled:"启用",
    Close:"关闭",
    change_password:'修改密码',
    The_default_password_for_the_new_user_is_123456_It_is_recommended_to_change_the_password_first_after_adding_a_new_user:'新增用户的密码默认为123456，建议在新增用户后先修改密码！',

    //耗材类型
    Add_consumables_type:"新增耗材类型",
    Edit_consumables_type:"编辑耗材类型",
    Consumable_name:"耗材名称",
    Description_of_consumables:"耗材描述",
    Please_enter_the_consumable_name:"请输入耗材名称",
    Please_enter_a_description_of_the_consumable:"请输入耗材描述",
    type_name:"类型名称",
    Type_description:"类型描述",
    Please_enter_Type_description:"请输入类型描述",
    Change_the_time:"修改时间",

    //耗材管理
    Add_consumables:"新增耗材",
    Add_consumable_information:"新增耗材信息",
    Editing_Supplies_Information:"编辑耗材信息",
    Consumables_Code:"耗材编码",
    Consumable_size:"耗材尺寸",
    Number_of_consumables:"耗材数量",
    single_standard_price:"单个标准价格",
    long:"长",
    width:"宽",
    height:"高",
    Please_enter_the_consumable_code:"请输入耗材编码",
    Please_enter_length_width_and_height:"请输入长宽高尺寸",
    Please_enter_the_quantity_of_consumables:"请输入耗材数量",
    Please_enter_a_single_standard_price:"请输入单个标准价格",
    Please_select_a_warehouse:"请选择仓库",
    Please_select_a_consumable_type:"请选择耗材类型",
    Consumable_Type:"耗材类型",
    Billing_way:"计费方式",

    //一件待发费设置
    download:"下载",
    Ready_to_download_do_not_manipulate_the_page:"准备下载，请勿操作页面",
    The_exported_file_may_be_larger_than_1MB_Some_browsers_block_the_download_and_therefore_fail_to_download_the_file_Set_this_parameter_by_yourself:'导出的文件可能会大于1MB，部分浏览器会进行拦截下载导致无法下载，请自行去设置',
    Drag_the_file_here:"将文件拖到此处",
    or:'或',
    Click_Upload:"点击上传",
    Click_Download:"点击下载",
    Momentumfee:"一件待发费设置",
    export:"导出",
    to_lead:"导入",
    You_need_to_use_a_consignment_template:"需要使用一件代发货模板",
    add:"添加",
    Batch_add:"批量添加",
    Batch_delete:"批量删除",
    date:"日期",
    The_longest_edge:"最长边",
    Long_side:"次长边",
    The_shortest_edge:"最短边",
    weight:"重量",
    number:"件数",
    SumThreeSides:"三边长总和",
    cost_a:"费用/个",
    Extra_charge:"续SKU操作费",
    One_charge:"首SKU操作费",
    One_Packaging_material:"首SKU包材费",
    Extra_Packaging_material:"续SKU包材费",
    Currency_type:"币种",
    The_exported_content_is_empty:'导出内容为空',
    Is_export_all:'是否全部导出',
    Packaging_material_cost: "包材费",
    Please_enter_Currency_type:"请输入币种",
    Please_enter_The_longest_edge:"请输入最长边",
    Please_enter_Long_side:"请输入次长边",
    Please_enter_The_shortest_edge:"请输入最短边",
    Tweiwtwri1kg200kg:"输入的重量有误，重量范围为1kg-200kg！",
    Please_enter_quantity:"请输入数量",
    Please_enter_weight:"请输入重量",
    Please_enter_SumThreeSides:"请输入三边长总和",
    Please_enter_cost_a:"请输入三边长总和",
    Please_enter_cost:"请输入费用",
    Please_enter_Extra_charge:"请输入续SKU操作费",
    Please_enter_One_charge:"请输入首SKU操作费",
    Please_enter_number:"请输入件数",
    Please_enter_One_Packaging_material:"请输入首SKU包材费",
    Please_enter_Extra_Packaging_material:"请输入续SKU包材费",
    Cancel_the_editor:"取消编辑",
    Cancel_the_add:"取消添加",
    Failed_to_start_the_camera_Please_check_whether_the_camera_is_available_Or_turn_on_the_camera_head:"摄像头开启失败，请检查摄像头是否可用！或者打开摄影头",
    This_operation_cannot_be_undone_Do_you_want_to_continue : "该操作将无法撤回，是否继续？",
    size:"尺寸",
    Please_select_size:"请选择尺寸",
    Three_high:"长宽高",
    Rate_number:'收费标准编号',
    Please_enter_Rate_number:'请输入收费标准编号',
    
    //扫描拍照
    outbound_pictures:"出库拍照",
    photo_list:"拍照列表",
    scan_pictures:"扫描拍照",
    scanning_waybill_number:"扫描运单号",
    The_operation_fails_Check_whether_the_input_of_the_waybill_number_is_correct:"操作失败，请查看运单号输入是否正确",
    
    //拍照列表
    Review_images:"查看图片",
    Operation_of:"操作人",
    start_time:"开始时间",
    end_time:"结束时间",
    Unselected_time:"未选择时间",
    Data_in_this_time_range_is_null:'该时间段数据为空!',
    exporting:'正在导出',

    //蓝子列表
    The_end_of_the_blue_subheader_cannot_be_a_number_Please_reenter:'输入的蓝子头末尾不能为数字,请重新输入',
    BasketListLog :'篮子使用日志',
    distributor:'配货人',
    Please_enter_distributor:'请输入配货人',
    picker:'拣货人',
    Please_enter_picker:'请输入拣货人',
    consigner:'发货人',
    Please_enter_consigner:'请输入发货人',
    Allotment_basket:'配货篮子',

    //三方仓发货
    tw:'三方仓',
    twShipments:'三方仓发货',
    TWDistribution:'三方仓配货',
    TWSorting:'三方仓分拣',
    is_Joint_order:'是否合单',
    The_weight_is_only_allowed_in_0_200KG:'重量只允许在0-200KG',
    Three_warehouse_orders_are_not_allowed_to_operate_multiple_shipments:'三方仓订单不允许操作多品发货',
    disposeTWAbnormal:'处理三方仓回传异常',
    Get_the_sheet_again:'重新获取面单',

    //取消订单
    cancellation_of_order:'取消订单',
    csFeededuction:'财务测试扣费',

    //温馨提示
    The_page_you_visited_does_not_exist_Please_check_whether_the_network_connection_is_normal_or_check_whether_the_address_input_is_correct:"您访问的页面不存在，请查看网络连接是否正常，或查看地址输入是否正确!",
    The_orders_that_have_been_shipped_and_failed_to_be_shipped_can_be_scanned_and_reprinted_here_Orders_that_have_been_shipped_can_be_reprinted_here_Note_The_order_must_be_the_order_placed_in_your_task_list:"已经发货扫描完成出货失败的订单，可以在此补印出货；已经出货的订单可以在此重新补印面单。（注：订单必须是您任务单下的订单）",
}